import { render, staticRenderFns } from "./DigitalGuideInfo.vue?vue&type=template&id=1c8492fc&scoped=true"
import script from "./DigitalGuideInfo.vue?vue&type=script&lang=js"
export * from "./DigitalGuideInfo.vue?vue&type=script&lang=js"
import style0 from "./DigitalGuideInfo.vue?vue&type=style&index=0&id=1c8492fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c8492fc",
  null
  
)

export default component.exports